import { render, staticRenderFns } from "./ChangeProfilePic.vue?vue&type=template&id=4dc6d882&scoped=true&"
import script from "./ChangeProfilePic.vue?vue&type=script&lang=js&"
export * from "./ChangeProfilePic.vue?vue&type=script&lang=js&"
import style0 from "./ChangeProfilePic.vue?vue&type=style&index=0&id=4dc6d882&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc6d882",
  null
  
)

export default component.exports